import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import { get } from 'lodash';

import DroppableList from './DroppableList';
import DraggableListItems from './DraggableListItems';
import { sortByFieldType } from '../reducer';
import { MEASURE, DIMENSION } from '../../../utils/report-builder';

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: grid * 2,
  margin: `${grid}px`,
  background: 'white',
  border: '1px solid #333333',
  ...draggableStyle
});

const PreFetchState = ({
  fields,
  toggleField,
  reorderList,
  hasView,
  hasAnyActiveField,
  values,
  pivots,
  pivotDragDisabled
}) => {
  if (hasView && hasAnyActiveField) return null;

  const droppableLists = { pivots, values };

  const onDragEnd = result => {
    const { source, destination, draggableId } = result;
    if (!destination) {
      return false;
    }

    if (source.droppableId === destination.droppableId) {
      const list = Array.from(droppableLists[source.droppableId]);
      const [removed] = list.splice(source.index, 1);
      list.splice(destination.index, 0, removed);

      if (source.droppableId === 'values') {
        list.sort(sortByFieldType);
      }

      return reorderList(list, destination.droppableId);
    }

    const field = get(fields, draggableId, {});

    if (field.fieldType === MEASURE && destination.droppableId === 'pivots') {
      return false;
    }

    return toggleField(
      field,
      destination.droppableId === 'pivots' || source.droppableId === 'pivots'
    );
  };

  return (
    <div className="tvt-empty-report__dnd-wrapper">
      {hasView && !hasAnyActiveField && (
        <DragDropContext onDragEnd={onDragEnd} onDragStart={() => {}}>
          <DroppableList
            droppableId="pivots"
            className="column-droppable"
            direction="horizontal"
            isDropDisabled={pivotDragDisabled}
          >
            <DraggableListItems
              items={pivots}
              style={getItemStyle}
              placeholder="Select dimension from left menu or drag from below to pivot."
            />
          </DroppableList>
          <DroppableList
            droppableId="values"
            className="value-droppable"
            direction="horizontal"
          >
            <DraggableListItems
              items={values.map(v => ({
                ...v,
                className:
                  get(v, 'fieldType', '') === DIMENSION
                    ? 'dimension'
                    : 'measure'
              }))}
              style={getItemStyle}
              placeholder="Select dimensions and metrics from the left menu."
            />
          </DroppableList>
        </DragDropContext>
      )}
    </div>
  );
};

PreFetchState.propTypes = {
  hasView: PropTypes.bool.isRequired,
  hasAnyActiveField: PropTypes.bool.isRequired,
  fields: PropTypes.shape({}).isRequired,
  toggleField: PropTypes.func.isRequired,
  reorderList: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({})),
  pivots: PropTypes.arrayOf(PropTypes.shape({})),
  pivotDragDisabled: PropTypes.bool
};

PreFetchState.defaultProps = {
  values: [],
  pivots: [],
  pivotDragDisabled: false
};

export default PreFetchState;
